export default "__VITE_ASSET__DLWzMMfg__"